import { useAppDisplayModeContext } from '@archipro-design/aria';

import type { PaginatedArticlesProps } from '@modules/articles/type';

import PaginatedArticlesDesktop from './PaginatedArticles.desktop';
import PaginatedArticlesMobile from './PaginatedArticles.mobile';

import { useSaveToDesignBoard } from '~/modules/design-board/hook/use-save-to-design-board';
import SaveToDesignBoard from '@modules/design-board/component/SaveToDesignBoard';

const PaginatedArticles: React.FC<PaginatedArticlesProps> = (props) => {
    const { mobile: isMobile } = useAppDisplayModeContext();
    const { favouriteItem } = useSaveToDesignBoard('ArticlePin');

    return (
        <>
            {isMobile ? (
                <PaginatedArticlesMobile
                    {...props}
                    favouriteItem={favouriteItem}
                />
            ) : (
                <PaginatedArticlesDesktop
                    {...props}
                    favouriteItem={favouriteItem}
                />
            )}
            {favouriteItem.target && (
                <SaveToDesignBoard {...favouriteItem} autoReposition={false} />
            )}
        </>
    );
};

export default PaginatedArticles;
